import axios from "axios";
import { useEffect, useState } from "react";
import ModalElement from "../components/generateModal";
import Header from "../components/header";
import '../index.scss';
type Recipe = {
    "title": string,
    "recipe_thumbnail": string,
    "recipe_url": string,
    "made_by":string,
}
export default Recipe
export const TestRecipe = () => {
    const [Recipes, setRecipes] = useState<Array<Recipe>>([])
    const [detectWord,setDetectWord] = useState('')
    const BaseURL = "https://mega-api-web.azurewebsites.net/api/v1/foods/"
    const [recipeData,setRecipeData] = useState<Array<Recipe>>([])
    const [recipeDataWithToken,setRecipeDataWithToken] = useState<Array<Recipe>>([])
    const [show, setShow] = useState(false)


    const handleDetectWord = (event:any) =>{
        event.preventDefault()
        setDetectWord(event.target.value)
    }


    const getRecipeByDetectWord = (event:any) =>{
        event.preventDefault()
        axios.get<[]>(BaseURL+'recipes/'+detectWord,
            {
                headers:{
                    "Content-type":"application/json",
                    "jwt-token": "Bearer "+document.cookie
                }
            }
        ).then((res) =>{
            console.log(res.data)
            setShow(true)
            setRecipeData(res.data)
        }).catch((error) =>{
            console.log(error)
        })
    }


    const getRecipeByToken = () =>{
        console.log(BaseURL+'recipes')
        axios.get<[]>(BaseURL+'recipes',{
            headers:{
                "Content-type":"application/json",
                "jwt-token": "Bearer "+document.cookie
            }
        }).then((res) =>{
            console.log(res.data);
            setRecipeDataWithToken(res.data)
        }).catch((error) =>{
            console.log(error)
        })
    }
    const changeDisplay = () =>{

    }
    useEffect(getRecipeByToken, [])
    return(
        <div className="stand">
            <Header/>
            {show&&<ModalElement
                recipe={recipeData}
                setShow ={setShow}
            ></ModalElement>}
            <div>
                <div className="">
                    <div className="m-auto ">
                        <form onSubmit={getRecipeByDetectWord} className="flex justify-center flex-wrap justify-around my-1">
                            <input
                                value={detectWord}
                                placeholder="調べたい料理を入力"
                                onChange={handleDetectWord}
                                className="border-2 px-12 text-center shadow-md rounded-full my-1 overflow-x-hidden"
                            />
                            <button type="submit" className="mx-2 rounded-lg px-3 shadow-md bg-slate-200 border-2 my-1">検索</button>
                        </form>

                    </div>
                    <div className="grid grid-cols-3">
                            {recipeDataWithToken.map((recipe,index) => (
                                <a key={index} className=" simple-linear border-2  shadow-md border-orange-200 p-auto m-2 rounded-lg">
                                    <div className=" my-3 mx-4">
                                        <img src={recipe.recipe_thumbnail} className=" shadow-md rounded-lg border-b-gray-500"/>
                                    </div>
                                    <a className="mx-2 text-center border-b-2 border-b-zinc-600 text-cyan-500 text-shadow-md shadow-slate-300" href={recipe.recipe_url}>{recipe.title}</a>
                                    <div className="mt-6">
                                        <div className=" text-xs">made by
                                            <div className="text-center">
                                                {recipe.made_by}

                                            </div>
                                        </div>
                                    </div>
                                </a>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    )
}